import PropTypes from 'prop-types';
import getProductPrice from 'util/misc/get-product-price';
import t from 'translations';
import formatPrice from 'util/misc/format-price';
import React from 'react';

function renderContent(price_information, realPrice) {
    if (price_information.original_price) {
        return (
            <div className="product-price--discount">
                <div className="product-price--price">
                    <span>{formatPrice(realPrice)}</span>
                </div>
                <div className="product-price--old-price">
                    {t('products.instead_of')} {formatPrice(price_information.original_price)}
                </div>
            </div>
        );
    }

    return (
        <div className="product-price--price">
            <span>{formatPrice(realPrice)}</span>
        </div>
    );
}

export default function ProductPrice({ price_information }) {
    return <div className="product-price">{renderContent(price_information, getProductPrice(price_information))}</div>;
}


ProductPrice.propTypes = {
    price_information: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-price/index.js